import React from 'react';

import { StyleSheet, Text, View } from 'react-native';

import { t } from 'state/intl/translations';
import { primitive } from 'styles/constants/primitives';

import { useCheckoutLoadingState } from '../../hooks';
import { useCheckoutValidation } from '../../hooks/use-checkout-validation';

interface ErrorTextProps {
  testID?: string;
}

export const ErrorText: React.FC<ErrorTextProps> = ({ testID = 'checkout-error-text' }) => {
  const { validate } = useCheckoutValidation();
  const checkoutErrors = validate();
  const { isCheckoutLoading } = useCheckoutLoadingState();

  if (checkoutErrors.length === 0 || isCheckoutLoading) {
    return null;
  }

  const errors = checkoutErrors.filter(error => error.placement === 'footer');

  if (errors.length === 1) {
    const error = errors[0];
    const displayMessage = error.message || (error.messageId ? t(error.messageId) : '');

    return (
      <Text style={styles.errorText} testID={testID}>
        {displayMessage}
      </Text>
    );
  }

  // If multiple errors, display them as a list
  return (
    <View testID={testID}>
      {errors.map((error, index) => {
        const displayMessage = error.message || (error.messageId ? t(error.messageId) : '');

        return (
          <Text key={error.type} style={styles.errorText}>
            • {displayMessage}
          </Text>
        );
      })}
    </View>
  );
};

const styles = StyleSheet.create({
  errorText: {
    color: primitive.bk.$alertRed,
    fontFamily: primitive.fontFamily.$body,
    fontSize: primitive.fontSizes.xs,
    marginBottom: 4,
    textAlign: 'center',
    paddingVertical: 8,
  },
});
